import React from 'react';
import { IconProps } from '../types';
const MinecraftFireworkRocket: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="2" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(214, 42, 42, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(109, 23, 23, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(109, 23, 23, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(109, 23, 23, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(132, 27, 27, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(178, 204, 209, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(178, 204, 209, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(132, 27, 27, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(244, 244, 244, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(178, 204, 209, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(244, 244, 244, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(178, 204, 209, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(244, 244, 244, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(244, 244, 244, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(244, 244, 244, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(153, 41, 41, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(178, 204, 209, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(45, 20, 9, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(45, 20, 9, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(185, 41, 41, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(45, 20, 9, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(178, 204, 209, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(45, 20, 9, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(45, 20, 9, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(45, 20, 9, 255)" />
</svg>);
export default MinecraftFireworkRocket;